document.addEventListener("DOMContentLoaded", async function () {
    /* ---------- CONFIG ---------- */
    const API = "https://services.rendezvous.lv"
    const HEALTH_CHECK = API+"/health"
    const MOCKUP_API = API+"/mockups";
    const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB
    const MAX_DIMENSION_PX = 9000;

    /* ---------- STATE ---------- */
    let wholesaleProduct;
    let catalog;

    let labelUploaded = false;
    let labelFileName = "";

    const mockupState = {
        ready: false,
        url: null,
        productHandle: null,
        container: null,
        variantId: null,
        fileName: null,
        requestId: 0,
    };

    let mockupRequestId = 0;
    let mockupPromise = null;
    let domainTouched = false;
    let mockupServiceHealthy = true;

    /* ---------- DOM ---------- */
    const productGrid = document.getElementById("wb-product-grid");
    const previewFrame = document.querySelector(".wb-preview-frame");
    const previewBox = document.getElementById("wb-preview-image");
    const previewPlaceholder = document.getElementById("wb-preview-placeholder");

    const labelInput = document.getElementById("wb-label-input");
    const uploadBtn = document.getElementById("wb-upload-btn");

    const tierContainer = document.getElementById("wb-tier-options");

    const domainInput = document.getElementById("wb-domain-input");
    const domainError = document.getElementById("wb-domain-error");

    const addToCartBtn = document.getElementById("wb-add-to-cart");
    const buyNowBtn = document.getElementById("wb-buy-now");

    const summaryProduct = document.getElementById("wb-summary-product");
    const summaryQty = document.getElementById("wb-summary-qty");
    const summaryTotal = document.getElementById("wb-summary-total");
    const summaryDomain = document.getElementById("wb-summary-domain");

    const ingredientsField = document.getElementById("ingredients");
    const uploadWarnings = document.getElementById("wb-upload-warnings");

    /* ---------- INGREDIENTS MAP: JSON METAFIELD ---------- */

    let ingredientsMap = {};
    try {
        const script = document.getElementById("wb-ingredients-json");
        if (script && script.textContent.trim()) {
            ingredientsMap = JSON.parse(script.textContent.trim());
        }
    } catch (e) {
        console.error("Failed to parse product_ingredients metafield:", e);
        ingredientsMap = {};
    }

    /* ---------- HELPERS: GENERAL ---------- */

    function parseSku(sku) {
        if (!sku) return { containerId: "DEFAULT", productCode: null, quantity: null };
        const parts = sku.split("-");
        return {
            containerId: parts[0] || "DEFAULT",
            productCode: parts[1] || null,
            quantity: parts[2] || null,
        };
    }

    function disableActions(disabled, reason) {
        const buttons = [addToCartBtn, buyNowBtn].filter(Boolean);
        buttons.forEach((btn) => {
            btn.disabled = disabled;
            btn.classList.toggle("wb-btn-disabled", disabled);
            if (reason) {
                btn.setAttribute("data-disabled-reason", reason);
            } else {
                btn.removeAttribute("data-disabled-reason");
            }
        });
    }

    function setUploadEnabled(enabled, reason) {
        if (uploadBtn) {
            uploadBtn.disabled = !enabled;
            uploadBtn.classList.toggle("wb-btn-disabled", !enabled);
            if (reason) {
                uploadBtn.setAttribute("data-disabled-reason", reason);
            } else {
                uploadBtn.removeAttribute("data-disabled-reason");
            }
        }
        if (labelInput) {
            labelInput.disabled = !enabled;
        }
    }

    function getDomain() {
        return domainInput ? domainInput.value.trim() : "";
    }

    function isLabelUploaded() {
        return labelUploaded;
    }

    function getSelectedProductHandle() {
        const selectedProduct = document.querySelector(".wb-product-chip.selected");
        return selectedProduct ? selectedProduct.dataset.handle : null;
    }

    function getSelectedTierElement() {
        return document.querySelector(".wb-tier-option.selected");
    }

    function isMockupValidForCurrentSelection() {
        const selectedProductHandle = getSelectedProductHandle();
        const selectedTier = getSelectedTierElement();

        if (!mockupState.ready || !selectedProductHandle || !selectedTier) {
            return false;
        }

        const currentContainer = selectedTier.dataset.container || "DEFAULT";

        return (
            mockupState.productHandle === selectedProductHandle &&
            mockupState.container === currentContainer &&
            mockupState.variantId === selectedTier.dataset.variantId
        );
    }

    function validateDomain(showMsg = true) {
        const value = getDomain();
        let msg = "";

        if (!value) {
            msg = "Domain is required.";
        } else if (!/^[a-z0-9.-]+\.[a-z]{2,}$/.test(value)) {
            msg = "Enter a valid domain (example: mystore.com).";
        }

        const ok = msg === "";

        if (showMsg && domainTouched) {
            domainError.textContent = msg;
        } else {
            domainError.textContent = "";
        }

        domainInput.classList.remove("wb-input-invalid", "wb-input-valid");
        if (domainTouched) {
            domainInput.classList.add(ok ? "wb-input-valid" : "wb-input-invalid");
        }

        return ok;
    }

    function updateSummary() {
        const selectedProductLabel = document.querySelector(
            ".wb-product-chip.selected .wb-product-chip-label"
        );
        summaryProduct.textContent = selectedProductLabel
            ? selectedProductLabel.textContent
            : "Not selected";

        const selectedTier = getSelectedTierElement();
        summaryQty.textContent = selectedTier ? `${selectedTier.dataset.qty} units` : "Not selected";

        if (selectedTier && selectedTier.dataset.total) {
            summaryTotal.textContent = `$${Number(selectedTier.dataset.total).toFixed(2)}`;
        } else {
            summaryTotal.textContent = "—";
        }

        const value = getDomain();
        summaryDomain.textContent = value || "No domain provided";
    }

    function validateAll() {
        const domainOk = validateDomain();
        const labelOk = isLabelUploaded();

        if (!mockupServiceHealthy) {
            disableActions(true, "Mockup generator is temporarily unavailable.");
        } else if (!domainOk) {
            disableActions(true, "Please enter a valid domain.");
        } else if (!labelOk) {
            disableActions(true, "Please upload your label.");
        } else {
            disableActions(false, "");
        }

        updateSummary();
    }

    async function loadWholesaleProduct() {
        const handle = "wholesale";
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error("White-Label product could not load.");
        return res.json();
    }

    /* ---------- HELPERS: UPLOAD WARNINGS ---------- */

    function clearUploadMessages() {
        if (!uploadWarnings) return;
        uploadWarnings.innerHTML = "";
    }

    function pushUploadMessage(message, tone) {
        if (!uploadWarnings || !message) return;

        const el = document.createElement("div");
        el.classList.add("wb-upload-message");

        if (tone === "error") {
            el.classList.add("wb-error");
        } else if (tone === "warning") {
            el.classList.add("wb-warning");
        } else {
            el.classList.add("wb-info");
        }

        el.textContent = message;
        uploadWarnings.appendChild(el);
    }

    /* ---------- HELPERS: IMAGE VALIDATION ---------- */

    function validateFileType(file) {
        const allowed = ["image/png", "image/jpeg", "image/jpg"];
        return allowed.includes(file.type);
    }

    function getImageDimensions(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function (e) {
                const img = new Image();
                img.onload = function () {
                    resolve({ width: img.width, height: img.height });
                };
                img.onerror = function () {
                    reject(new Error("Unable to read image dimensions."));
                };
                img.src = e.target.result;
            };
            reader.onerror = function () {
                reject(new Error("Unable to read file for dimension check."));
            };
            reader.readAsDataURL(file);
        });
    }

    function evaluateResolutionWarning(width, height) {
        const smallestSide = Math.min(width, height);

        if (smallestSide < 300) {
            return {
                tone: "error",
                message:
                    "Your label image is extremely low resolution and may appear very blurry in the mockup.",
            };
        }

        if (smallestSide < 600) {
            return {
                tone: "warning",
                message:
                    "Your label image may appear slightly low quality in the mockup. Consider using a higher resolution file.",
            };
        }

        return null;
    }

    async function validateLabelFile(file) {
        clearUploadMessages();

        if (!file) {
            return false;
        }

        if (!validateFileType(file)) {
            pushUploadMessage("Please upload a PNG or JPG image file.", "error");
            if (labelInput) labelInput.value = "";
            return false;
        }

        if (file.size > MAX_FILE_SIZE_BYTES) {
            pushUploadMessage(
                "Your file is too large. Please upload a smaller image (under 25 MB).",
                "error"
            );
            if (labelInput) labelInput.value = "";
            return false;
        }

        let dims;
        try {
            dims = await getImageDimensions(file);
        } catch (e) {
            console.error(e);
            pushUploadMessage(
                "We couldn't read your image dimensions. Please try a different file.",
                "error"
            );
            if (labelInput) labelInput.value = "";
            return false;
        }

        const width = dims.width;
        const height = dims.height;

        if (width > MAX_DIMENSION_PX || height > MAX_DIMENSION_PX) {
            pushUploadMessage(
                "Your image is extremely large. Please upload a smaller label image.",
                "error"
            );
            if (labelInput) labelInput.value = "";
            return false;
        }

        const resolutionWarning = evaluateResolutionWarning(width, height);
        if (resolutionWarning) {
            pushUploadMessage(resolutionWarning.message, resolutionWarning.tone);
        }

        pushUploadMessage(
            "You can try different sizes. Our team will review your label during order processing.",
            "info"
        );

        return true;
    }

    /* ---------- BUILD CATALOG WITH INGREDIENTS ---------- */

    function buildCatalog(productData) {
        const grouped = {};

        productData.variants.forEach((variant) => {
            const productName = variant.option1;
            const qty = Number(variant.option2);
            const total = Number(variant.price) / 100;

            const parsed = parseSku(variant.sku);
            const productCode = parsed.productCode ? parsed.productCode.toUpperCase() : null;

            const ingredients =
                productCode && ingredientsMap[productCode] ? ingredientsMap[productCode] : "";

            if (!grouped[productName]) {
                grouped[productName] = {
                    name: productName,
                    handle: productName.toLowerCase().replace(/\s+/g, "-"),
                    tiers: [],
                    base_price: null,
                    container: parsed.containerId || "DEFAULT",
                    imageSrc: (variant.featured_image && variant.featured_image.src) || null,
                    productCode: parsed.productCode || null,
                    ingredients: ingredients,
                };
            }

            const product = grouped[productName];

            if (!product.ingredients && ingredients) {
                product.ingredients = ingredients;
            }

            if (!product.imageSrc && variant.featured_image && variant.featured_image.src) {
                product.imageSrc = variant.featured_image.src;
            }

            const unitPrice = total / qty;

            if (qty === 1 && !product.base_price) {
                product.base_price = unitPrice;
            }

            product.tiers.push({
                qty: qty,
                total: total,
                unit_price: unitPrice,
                variant_id: variant.id,
                sku: variant.sku,
                container: parsed.containerId || "DEFAULT",
            });
        });

        return {
            products: Object.values(grouped).map((p) => {
                p.tiers.sort((a, b) => a.qty - b.qty);
                return p;
            }),
        };
    }

    /* ---------- IMAGE & RENDERING ---------- */

    async function loadProductImage(product) {
        if (product.imageSrc) return product.imageSrc;

        const container = product.container || "DEFAULT";
        return (
            "https://rs112501-mockup.fsn1.your-objectstorage.com/system/containers/" +
            container +
            ".png"
        );
    }

    async function updatePreviewContainer(product) {
        mockupState.ready = false;
        mockupState.url = null;

        if (previewPlaceholder) {
            previewPlaceholder.textContent = "Loading preview…";
        }
        if (previewFrame) {
            previewFrame.classList.remove("wb-preview-has-image", "wb-preview-loading");
        }
        if (previewBox) {
            previewBox.style.backgroundImage = "";
        }

        const url = await loadProductImage(product);

        if (previewBox) {
            previewBox.style.backgroundImage = 'url("' + url + '")';
        }
        if (previewFrame) {
            previewFrame.classList.add("wb-preview-has-image");
        }
        if (previewPlaceholder) {
            previewPlaceholder.textContent = "Your mockup will appear here.";
        }
    }

    function renderProductGrid() {
        if (!productGrid) return;
        productGrid.innerHTML = "";

        catalog.products.forEach((p) => {
            const el = document.createElement("button");
            el.type = "button";
            el.classList.add("wb-product-chip");
            el.dataset.handle = p.handle;
            el.innerHTML = '<span class="wb-product-chip-label">' + p.name + "</span>";

            el.addEventListener("click", async function () {
                const chips = document.querySelectorAll(".wb-product-chip");
                chips.forEach((o) => o.classList.remove("selected"));
                el.classList.add("selected");

                await updatePreviewContainer(p);
                renderTiers(p.handle);

                if (ingredientsField) {
                    ingredientsField.textContent = p.ingredients || "";
                }

                validateAll();
            });

            productGrid.appendChild(el);
        });

        const first = productGrid.querySelector(".wb-product-chip");
        if (first) {
            first.classList.add("selected");
            const fp = catalog.products.find((p) => p.handle === first.dataset.handle);
            if (fp) {
                updatePreviewContainer(fp);
                renderTiers(fp.handle);
                if (ingredientsField) {
                    ingredientsField.textContent = fp.ingredients || "";
                }
            }
            validateAll();
        }
    }

    function renderTiers(handle) {
        if (!tierContainer) return;
        tierContainer.innerHTML = "";

        const product = catalog.products.find((p) => p.handle === handle);
        if (!product) return;

        product.tiers.forEach((t) => {
            const baseTotal = product.base_price * t.qty;
            const savings = baseTotal - t.total;
            const percent =
                savings > 0.005 && baseTotal > 0 ? Math.round((savings / baseTotal) * 100) : 0;

            const el = document.createElement("div");
            el.classList.add("wb-tier-option");
            el.dataset.qty = String(t.qty);
            el.dataset.total = String(t.total);
            el.dataset.variantId = String(t.variant_id);
            el.dataset.sku = t.sku || "";
            el.dataset.container = t.container || "DEFAULT";

            const savingsHtml =
                savings > 0.005
                    ? '<div class="wb-tier-savings">Save $' +
                    savings.toFixed(2) +
                    " (" +
                    percent +
                    "%)</div>"
                    : "";

            el.innerHTML =
                '<div class="wb-tier-header-row">' +
                '<div class="wb-tier-header">' +
                t.qty +
                " units</div>" +
                savingsHtml +
                "</div>" +
                '<div class="wb-tier-sub">$' +
                t.unit_price.toFixed(2) +
                " per unit • Total: $" +
                t.total.toFixed(2) +
                "</div>";

            el.addEventListener("click", function () {
                const options = tierContainer.querySelectorAll(".wb-tier-option");
                options.forEach((o) => o.classList.remove("selected"));
                el.classList.add("selected");
                validateAll();
            });

            tierContainer.appendChild(el);
        });

        const first = tierContainer.querySelector(".wb-tier-option");
        if (first) {
            first.classList.add("selected");
        }
    }

    /* ---------- MOCKUP GENERATION ---------- */

    async function generateMockup(file, container, variantId) {
        mockupState.ready = false;
        mockupState.url = null;

        if (previewFrame) {
            previewFrame.classList.add("wb-preview-loading");
            previewFrame.classList.remove("wb-preview-has-image");
        }
        if (previewPlaceholder) {
            previewPlaceholder.textContent = "Generating mockup…";
        }

        clearUploadMessages();
        pushUploadMessage("Generating your mockup…", "info");

        const fd = new FormData();
        fd.append("label", file);
        fd.append("container", container);

        const requestId = ++mockupRequestId;
        mockupState.requestId = requestId;

        try {
            const res = await fetch(MOCKUP_API, {
                method: "POST",
                body: fd,
            });
            if (!res.ok) throw new Error("Mockup request failed.");

            const data = await res.json();
            const url = data.package && data.package.mockup ? data.package.mockup : null;
            if (!url) throw new Error("Missing mockup URL in API response.");

            if (requestId !== mockupRequestId) {
                // Outdated request; ignore.
                return;
            }

            mockupState.ready = true;
            mockupState.url = url;
            mockupState.productHandle = getSelectedProductHandle();
            mockupState.container = container;
            mockupState.variantId = variantId;
            mockupState.fileName = labelFileName;

            if (previewBox) {
                previewBox.style.backgroundImage = 'url("' + url + '")';
            }
            if (previewFrame) {
                previewFrame.classList.add("wb-preview-has-image");
                previewFrame.classList.remove("wb-preview-loading");
            }
            if (previewPlaceholder) {
                previewPlaceholder.textContent = "";
            }

            clearUploadMessages();
            pushUploadMessage(
                "Feel free to try adjusting label dimensions and preview again. Our team will review during order processing.",
                "info"
            );

            validateAll();
        } catch (e) {
            console.error("Mockup error:", e);
            mockupState.ready = false;
            mockupState.url = null;

            if (previewPlaceholder) {
                previewPlaceholder.textContent =
                    "Error generating mockup. Please try again or upload a different label.";
            }
            if (previewFrame) {
                previewFrame.classList.remove("wb-preview-loading");
            }

            clearUploadMessages();
            pushUploadMessage(
                "We couldn't generate your mockup. Please try again with the same label or a different file. If issues persist, contact support.",
                "error"
            );

            validateAll();
            throw e;
        }
    }

    async function ensureMockupForCurrentSelection() {
        const selectedTier = getSelectedTierElement();
        const file = labelInput && labelInput.files ? labelInput.files[0] : null;

        if (!selectedTier || !file) {
            throw new Error("Missing selection or label file for mockup generation.");
        }

        if (isMockupValidForCurrentSelection()) {
            return;
        }

        if (!mockupPromise) {
            const container = selectedTier.dataset.container || "DEFAULT";
            const variantId = selectedTier.dataset.variantId;

            mockupPromise = generateMockup(file, container, variantId)
                .catch((e) => {
                    throw e;
                })
                .finally(() => {
                    mockupPromise = null;
                });
        }

        await mockupPromise;

        if (!isMockupValidForCurrentSelection()) {
            throw new Error("Mockup is not valid for the current selection after generation.");
        }
    }

    function setButtonLoading(btn, text) {
        const labelSpan = btn.querySelector("span");
        if (labelSpan) {
            btn.dataset.originalText = labelSpan.textContent;
            labelSpan.textContent = text;
        }
        btn.classList.add("wb-btn-loading");
        btn.disabled = true;
    }

    function clearButtonLoading(btn) {
        const labelSpan = btn.querySelector("span");
        if (labelSpan && btn.dataset.originalText) {
            labelSpan.textContent = btn.dataset.originalText;
            delete btn.dataset.originalText;
        }
        btn.classList.remove("wb-btn-loading");
    }

    /* ---------- HEALTH CHECK ---------- */

    async function checkMockupHealth() {
        try {
            const res = await fetch(HEALTH_CHECK, { method: "GET" });
            mockupServiceHealthy = res.ok;
        } catch (e) {
            console.error("Mockup health check failed:", e);
            mockupServiceHealthy = false;
        }

        if (!mockupServiceHealthy) {
            setUploadEnabled(false, "Mockup generator is temporarily unavailable.");
            clearUploadMessages();
            pushUploadMessage(
                "Label upload is temporarily disabled. Please come back and try again later.",
                "error"
            );
            disableActions(true, "Mockup generator is temporarily unavailable.");
        }
    }

    /* ---------- EVENT HANDLERS ---------- */

    if (uploadBtn && labelInput) {
        uploadBtn.addEventListener("click", function () {
            if (!mockupServiceHealthy) {
                clearUploadMessages();
                pushUploadMessage(
                    "Label upload is currently disabled because the mockup generator is unavailable.",
                    "error"
                );
                return;
            }

            labelInput.value = "";
            labelInput.click();
        });

        labelInput.addEventListener("change", async function () {
            if (!mockupServiceHealthy) {
                clearUploadMessages();
                pushUploadMessage(
                    "Label upload is currently disabled.",
                    "error"
                );
                labelInput.value = "";
                return;
            }

            const file = labelInput.files && labelInput.files[0];
            if (!file) return;

            const selectedTier = getSelectedTierElement();
            if (!selectedTier) {
                clearUploadMessages();
                pushUploadMessage(
                    "Please select a product and quantity before uploading your label.",
                    "warning"
                );
                labelInput.value = "";
                return;
            }

            const valid = await validateLabelFile(file);
            if (!valid) {
                labelUploaded = false;
                labelFileName = "";
                validateAll();
                return;
            }

            labelUploaded = true;
            labelFileName = file.name;
            validateAll();

            const container = selectedTier.dataset.container || "DEFAULT";
            const variantId = selectedTier.dataset.variantId;

            try {
                await generateMockup(file, container, variantId);
            } catch (e) {
                // error messaging already handled in generateMockup
            }
        });
    }

    async function handleAddToCart(triggerBtn) {
        if (!validateDomain() || !isLabelUploaded()) return;

        const selectedTier = getSelectedTierElement();
        const selectedProduct = document.querySelector(".wb-product-chip.selected");
        if (!selectedTier || !selectedProduct) return;

        setButtonLoading(triggerBtn, "Generating mockup…");
        disableActions(true, "Generating mockup for your order…");

        try {
            await ensureMockupForCurrentSelection();
        } catch (e) {
            console.error(e);
            if (previewPlaceholder) {
                previewPlaceholder.textContent =
                    "Error generating mockup. Please try again or upload a different label.";
            }
            clearButtonLoading(triggerBtn);
            validateAll();
            return;
        }

        clearButtonLoading(triggerBtn);
        validateAll();

        const uploadedLabelName =
            labelFileName ||
            (labelInput && labelInput.files && labelInput.files[0]
                ? labelInput.files[0].name
                : "");

        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                items: [
                    {
                        id: Number(selectedTier.dataset.variantId),
                        quantity: 1,
                        properties: {
                            Domain: getDomain(),
                            "Uploaded label": uploadedLabelName,
                            _mockup_url: mockupState.url || "",
                            _mockup_container: selectedTier.dataset.container,
                            _unit_price: (
                                selectedTier.dataset.total / selectedTier.dataset.qty
                            ).toFixed(2),
                            _total_price: selectedTier.dataset.total,
                            _product_handle: selectedProduct.dataset.handle,
                            _variant_id: selectedTier.dataset.variantId,
                            _sku: selectedTier.dataset.sku,
                            _mockup_ready: mockupState.ready ? "true" : "false",
                        },
                    },
                ],
            }),
        });

        window.location.href = "/cart";
    }

    if (addToCartBtn) {
        addToCartBtn.addEventListener("click", function () {
            handleAddToCart(addToCartBtn);
        });
    }

    if (buyNowBtn) {
        buyNowBtn.addEventListener("click", function () {
            handleAddToCart(buyNowBtn);
        });
    }

    if (domainInput) {
        domainInput.addEventListener("input", function () {
            domainTouched = true;
            validateAll();
        });

        domainInput.addEventListener("blur", function () {
            domainTouched = true;
            validateAll();
        });
    }

    /* ---------- INIT ---------- */

    try {
        await checkMockupHealth();
        wholesaleProduct = await loadWholesaleProduct();
        catalog = buildCatalog(wholesaleProduct);
        renderProductGrid();
        validateAll();
    } catch (e) {
        console.error("White-Label builder could not initialize:", e);
        clearUploadMessages();
        pushUploadMessage(
            "The builder could not fully initialize. Please refresh the page or try again later.",
            "error"
        );
        disableActions(true, "Builder initialization failed.");
        setUploadEnabled(false, "Builder initialization failed.");
    }
});